import * as React from "react";
import {t} from "i18next";
import {PSLCopyResultSummaryDto} from "src/services/Client";
import {Dialog} from "../../../components/Dialogs/Dialog";
import {Button} from "../../../components/Button";

interface IPSLCopyResultSummaryDialogProps {
    pslCopyResultSummary: PSLCopyResultSummaryDto;
    onConfirm(): void;
}

export const PSLCopyResultSummaryDialog: React.StatelessComponent<IPSLCopyResultSummaryDialogProps> = (props: IPSLCopyResultSummaryDialogProps) => {
    return (
        <Dialog
            open={true}
            title={t("PSL_COPY:COPY_MY_PSL_SUMMARY")}
            actions={[
                (
                    <Button
                        key={"submitButton"}
                        icon={"checkmark"}
                        onClick={props.onConfirm}
                    />
                )
            ]}
        >

            <p>{t("PSL_COPY:COPY_PSL_BM_PROCESSED") + ': ' + (props.pslCopyResultSummary.toProcessBMOptions ?
                props.pslCopyResultSummary.toProcessBMOptions.length : '0')}</p>
            <hr />

            <p>{t("PSL_COPY:COPY_PSL_SM_PROCESSED") + ': ' + (props.pslCopyResultSummary.toProcessSMOptions ?
                props.pslCopyResultSummary.toProcessSMOptions.length : '0')}</p>
            <hr />

            <p>{t("PSL_COPY:COPY_PSL_NO_CONFLICTS_BM") + ': ' + (props.pslCopyResultSummary.copiedBMOptions ?
                props.pslCopyResultSummary.copiedBMOptions.length : '0')}</p>
            <hr />

            <p>{t("PSL_COPY:COPY_PSL_NO_CONFLICTS_SM") + ': ' + (props.pslCopyResultSummary.copiedSMOptions ?
                props.pslCopyResultSummary.copiedSMOptions.length : '0')}</p>
            <hr />

            <p>{t("PSL_COPY:COPY_PSL_OBS") + ': ' + (props.pslCopyResultSummary.copiedBasicOptions ?
                props.pslCopyResultSummary.copiedBasicOptions.length : '0')}</p>
            <hr />

            <p>{t("PSL_COPY:COPY_PSL_BM_WITH_CONFLICTS") + ': ' + (props.pslCopyResultSummary.inConflictBMOptions ?
                props.pslCopyResultSummary.inConflictBMOptions.length : '0')}</p>
            <hr />

            <p>{t("PSL_COPY:COPY_PSL_BM_ERRORS") + ': ' + (props.pslCopyResultSummary.errorBMOptions ?
                props.pslCopyResultSummary.errorBMOptions.length : '0')}</p>
            <hr />

            <p>{t("PSL_COPY:COPY_PSL_SM_ERRORS") + ': ' + (props.pslCopyResultSummary.errorSMOptions ?
                props.pslCopyResultSummary.errorSMOptions.length : '0')}</p>
        </Dialog>
    );
};



// WEBPACK FOOTER //
// ./src/views/OptionsView/PSL/PSLCopyResultSummaryDialog.tsx